// Client-side multi-currency display. Uses INR base amount (price_inr) when
// available so switching currency is instant across the whole UI.
const RATES_TO_INR = {
  INR: 1.0, USD: 83.3, EUR: 90.1, GBP: 105.4, JPY: 0.56,
  SGD: 61.8, AED: 22.7, THB: 2.35, AUD: 54.2,
};
export const SYMBOLS = {
  INR: '₹', USD: '$', EUR: '\u20ac', GBP: '\u00a3', JPY: '\u00a5',
  SGD: 'S$', AED: 'AED ', THB: '\u0e3f', AUD: 'A$',
};

export function convertFromInr(amountInr, to) {
  const rate = RATES_TO_INR[to] || 1;
  return amountInr / rate;
}

export function formatPrice(amountInr, currency = 'INR', opts = {}) {
  const val = convertFromInr(amountInr, currency);
  const sym = SYMBOLS[currency] || currency + ' ';
  if (opts.compact) {
    const abs = Math.abs(val);
    if (abs >= 100000) return `${sym}${(val / 100000).toFixed(1).replace(/\.0$/, '')}L`;
    if (abs >= 1000) return `${sym}${(val / 1000).toFixed(1).replace(/\.0$/, '')}k`;
    return `${sym}${Math.round(val)}`;
  }
  const rounded = Math.round(val);
  return `${sym}${rounded.toLocaleString('en-IN')}`;
}

export function symbol(currency) {
  return SYMBOLS[currency] || currency;
}
